import { formatCurrency } from '~/lib/CurrencyHelpers.js';
import { SelectionImage } from '~/components/forms/questions/components/SelectionBlock.jsx';

const SelectionSelectedBlock = ({
    image,
    title,
    price,
    onChange,
    selectedRightContent,
}) => {
    return (
        <section className="choose-block choose-block-selected flex">
            {!!image && (
                <div onClick={() => onChange()} className="pl-6">
                    <SelectionImage image={image} />
                </div>
            )}
            <div className="flex-1 p-6" onClick={() => onChange()}>
                <p className="font-medium">{title || ''}</p>
                <p>{price ? formatCurrency(price) : ''}</p>
            </div>
            <div>
                {!!selectedRightContent && (
                    <div className="pr-6 pb-4">{selectedRightContent}</div>
                )}
                {!selectedRightContent && (
                    <button
                        type="button"
                        onClick={() => onChange()}
                        className="mr-6 btn-inverse btn-small text-sm btn-light-pill-sm uppercase"
                    >
                        Change
                    </button>
                )}
            </div>
        </section>
    );
};

export default SelectionSelectedBlock;
